import { ChildMachineConfig } from "@checkout/types";
import { ActionTypes } from "./actions";
import { GuardTypes } from "./guards";
import { CancelForAnyReasonStateV2 } from "./types";

export const getCancelForAnyReasonMachineV2 = (config: ChildMachineConfig) => ({
  initial: CancelForAnyReasonStateV2.route,
  states: {
    [CancelForAnyReasonStateV2.route]: {
      always: [
        {
          target: CancelForAnyReasonStateV2.addProduct,
          cond: GuardTypes.hasCfarIdAndEnabled,
        },
        {
          target: config.nextState,
        },
      ],
    },
    [CancelForAnyReasonStateV2.addProduct]: {
      always: [
        {
          actions: [ActionTypes.addCfarProduct],
          target: config.nextState,
        },
      ],
    },
  },
});
